import { createFileRoute, useParams } from '@tanstack/react-router';
import { SectionFormWrapper, AttributeRenderer, RenderContentProps } from '../../../-shared';
import { useGetBaseCertificationDetail, useUpdateBaseCertificationDetail } from '../../../-shared/-query';
export const Route = createFileRoute('/_staff/certification/$id/_layout/_index/')({
  component: BaseCertificationDetail
});
function BaseCertificationDetail() {
  const {
    id
  } = useParams({
    from: '/_staff/certification/$id/_layout/_index/'
  });
  return <SectionFormWrapper useGetDetailQuery={useGetBaseCertificationDetail(id)} useSaveMutation={useUpdateBaseCertificationDetail(id)} renderContent={({
    section
  }: RenderContentProps) => <AttributeRenderer attributes={section.attributes} sectionKey={String(section.sectionKey)} />} />;
}